import React from 'react';
import Loadable from 'react-loadable';

const LoadableReportViewer = Loadable( {
  loader: () => import( /* webpackChunkName: "ReportViewerChunk" */ '../presentation/ReportViewer' ),
  loading: () => <div> LOADING </div>,  
} );

class ProductionReports extends React.Component {
  render( ) {
    return (
      <LoadableReportViewer header="Production Reports" reportpath="/production" />
    );
  }
}

export default ProductionReports;



// WEBPACK FOOTER //
// ./src/reports/ProductionReports.js